import React from 'react';
import ColorInputADG3 from './color_input_adg3';

export default function(props) {
  return <ColorInputADG3 {...props} />;
}
